/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
"use client";
import { Box, Button, Divider, Grid, Modal, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDownload } from "../../components/AppSection";
import AudioPlayer from "../../components/AudioPlayer";
import { SocialShare } from "../../components/FBSocial";
import { GoogleBannerAds, GoogleGridAds } from "../../components/GoogleAds";
import Iconify from "../../components/Iconify";
import Markdown from "../../components/Markdown";
import useLocales from "../../hooks/useLocales";
import { setExamSituation, setHint } from "../../redux/slices/gplx.exam.slice";
import CommentList from "../comment/CommentList";
import CommentNewForm from "../comment/CommentNewForm";
import ExamPlayerPreview from "./ExamPlayerPreview";
import ExamResultSection from "./ExamResultSection";

const style = {
  position: 'absolute',
  bgcolor: 'background.paper',
  boxShadow: 24,
  width: "100%",
  p: 2,
  margin: 0
};

function VideoExamSection({ item }) {
  let theme = useTheme();
  const dispatch = useDispatch();
  const { exam, examSituation, hint } = useSelector((state) => state.examS);
  const [resultDialog, setResultDialog] = useState(true);
  const { translate } = useLocales();

  const spaceHandle = () => {
    const st = { ...examSituation, isAnswered: true };
    dispatch(setExamSituation(st));
  };

  const handleCloseHint = () => {
    dispatch(setHint(false));
  };

  const handleOpenHint = () => {
    dispatch(setHint(true));
  };

  const getCurrentSituation = () => exam?.examSituations.find(item => item.id === examSituation?.id);

  const anwserCounter = exam?.examSituations.filter(item => item.isAnswered !== undefined).length;

  useEffect(() => {
    setResultDialog(exam?.status === "Kết thúc" ? true : false);
  }, [exam]);

  return (
    <Grid container mb={5} spacing={1}>
      <Grid item xs={12} md={9.5}>
        <Stack spacing={1} sx={{ position: 'relative' }}>
          <ExamPlayerPreview />
          <Modal disablePortal open={hint} onClose={handleCloseHint} style={{ position: 'absolute' }}>
            <Box sx={{ ...style }} >
              <Markdown children={examSituation?.situation.description} />
              <AudioPlayer text={examSituation?.situation.description} />
              <Button onClick={handleCloseHint} sx={{ px: 5, float: 'right' }} color="warning" variant="contained" size="medium" >{hint ? "Ẩn gợi ý" : "Gợi ý"}</Button>
            </Box>
          </Modal>
          <Modal disablePortal open={resultDialog} onClose={() => setResultDialog(false)} style={{ position: 'absolute' }}>
            <Box sx={{ ...style }} >
              <ResultContent />
              <Button onClick={() => setResultDialog(false)} sx={{ px: 5, float: 'right' }} color="warning" variant="contained" size="medium" >Đóng lại</Button>
            </Box>
          </Modal>
          <Typography variant="body1" textAlign={"center"}>{item.title}</Typography>
          <Stack direction={"row"} bgcolor={theme.palette.background.neutral} spacing={5} p={1} alignItems={"center"}>
            <Typography flex={1} variant="subtitle1">Đã làm: {anwserCounter}/{exam?.examSituations.length}</Typography>
            <Typography flex={1} variant="subtitle1">Điểm: {getCurrentSituation()?.score} ({getCurrentSituation()?.seletedTime && (Math.round(getCurrentSituation()?.seletedTime * 10) / 10)}s)</Typography>
            <Button onClick={handleOpenHint} sx={{ px: 5 }} color="warning" variant="contained" size="medium" >{hint ? "Ẩn gợi ý" : "Gợi ý"}</Button>
          </Stack>
          <Stack direction={"row"} spacing={1}>
            <Button onClick={spaceHandle} fullWidth variant="contained" size="large" disabled={exam?.status === "Kết thúc"}> SPACE (Phím cách)</Button>
          </Stack>
          <Score />
          {exam && <>
            <SocialShare title={exam?.metaTitle} />
            <Stack sx={{ display: 'flex', mb: 2 }}>
              <Typography variant="h4">{translate("button.comment")}</Typography>
              <Typography variant="caption">Ấn SPACE trước khi bình luận nhé</Typography>
            </Stack>
            <CommentNewForm itemId={exam.id} type="SITUATIONEXAM" />
            <CommentList />
          </>}
        </Stack >
      </Grid>
      <Grid item xs={12} md={2.5}>
        <ExamResultSection />
        <GoogleBannerAds />
      </Grid>
      <Grid item xs={12} md={12}>
        <GoogleGridAds />
      </Grid>
    </Grid>
  );
}

function Score() {
  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1">PHƯƠNG PHÁP CHẤM ĐIỂM</Typography>
      <Typography variant="body1">Bài thi thử mô phỏng của bạn sẽ có 10 tình huống:</Typography>
      <Typography variant="body1"><strong>+ 35 điểm:</strong> tối thiểu để vượt qua bài thi.</Typography>
      <Typography variant="body1"><strong>+ 50 điểm:</strong> tối đa bạn có thể đạt được.</Typography>
      <Typography variant="body1">Trong mỗi tình huống có 02 mốc thời điểm 5đ và 0đ:</Typography>
      <Typography variant="body1"><strong>+ 5 điểm:</strong> thời điểm bắt đầu có dấu hiệu phát hiện ra tình huống nguy hiểm, lái xe cần xử lý.</Typography>
      <Typography variant="body1"><strong>+ 0 điểm:</strong> mốc thời điểm mà xử lý từ thời điểm này vẫn xảy ra tai nạn</Typography>
      <Typography variant="body1"> Học viên lựa chọn được giữa 2 mốc này sẽ đạt mức điểm tương ứng từ <strong>5-4-3-2-1 điểm</strong> (điểm tối đa cho mỗi tình huống là 5đ).</Typography>
    </Stack>
  );
}

const ResultContent = () => {
  const { exam } = useSelector((state) => state.examS);
  const total = exam?.examSituations.map(item => item.score || 0).reduce((a, b) => a + b, 0);

  return (<Stack>
    <Stack direction="row" justifyContent="center" alignItems="center" spacing={0.5}>
      <Iconify icon={'wpf:statistics'} />
      <Typography variant="subtitle1" p={1}> KẾT QUẢ BÀI THI MÔ PHỎNG</Typography>
    </Stack >
    <Divider />
    <Grid container>
      <Grid item sm={8}>
        <Stack m={1} p={1} spacing={1} >
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: "center" }} >
            <Iconify icon={'mdi:paper-text-outline'} />
            <Typography variant="body1" px={1} >Đề thi:</Typography>
            <Typography variant="subtitle1" >Đề số {exam?.orderNo} </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: "center" }} >
            <Iconify icon={'mdi:question-mark-rhombus-outline'} />
            <Typography variant="body1" px={1} >Số tình huống:</Typography>
            <Typography variant="subtitle1" >{exam?.examSituations.length} </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: "center" }} >
            <Iconify icon={'material-symbols:check-circle-outline'} />
            <Typography variant="body1" px={1} >Điểm:</Typography>
            <Typography variant="subtitle1" color={total >= 35 ? "green" : "red"} >{total}/50</Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: "center" }} >
            <Iconify icon={'mdi:web-cancel'} />
            <Typography variant="body1" px={1} >Tại:</Typography>
            <Typography variant="subtitle1">onthibanglaixe.net</Typography>
          </Box>
        </Stack>
      </Grid>
      <Grid item sm={4}>
        <Stack alignItems="center" justifyItems={"center"} m={2} p={1} spacing={1}
          sx={{ border: 0.1, borderColor: "grey.400", borderRadius: 1 }}>
          <Typography variant="subtitle1"> KẾT QUẢ</Typography>
          {total >= 35 ?
            <>
              <Iconify icon={'healthicons:award-trophy'} sx={{ color: 'green', fontSize: 40 }} />
              <Typography variant="subtitle1" color={"primary"} px={1} textAlign={"center"}>ĐÃ ĐẠT</Typography>
            </> :
            <>
              <Iconify icon={'ri:emotion-sad-line'} sx={{ color: 'red', fontSize: 40 }} />
              <Typography variant="subtitle1" color={"error"} px={1} textAlign={"center"}>ĐÃ TRƯỢT</Typography>
            </>
          }
        </Stack >
      </Grid>
    </Grid>
    <TableContainer component={Paper}>
      <Table size="small" border={1} style={{ border: 1 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={{ fontWeight: 500 }}>Câu hỏi</TableCell>
            {exam?.examSituations.map((item) => (
              <TableCell key={item.id}>{item.orderNo}</TableCell>
            ))}
          </TableRow>
          <TableRow>
            <TableCell sx={{ fontWeight: 500 }} >Điểm</TableCell>
            {exam?.examSituations.map((item) => (
              <TableCell key={item.id} sx={{ color: item.score > 0 ? 'auto' : 'red' }}>
                {item.isAnswered ? item.score : 0}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
    <AppDownload />
    <SocialShare title={exam?.metaTitle} />
    <Divider sx={{ mb: 1 }} />
  </Stack>);
};

export default VideoExamSection;
